import { useTranslation } from 'react-i18next';
import { useTimeout } from '../../../hooks/useTimeout';
import { Icon } from '../../UI';
import React, { forwardRef, useImperativeHandle } from 'react';
import { Loading } from '../../UI';

interface SearchAssetsInputProps {
  onFinishTyping: (searchTerm: string | '') => void;
  loading: boolean;
  placeholder?: string;
  size?: 'full' | 'auto';
}

export const SearchAssetsInput = forwardRef<any, SearchAssetsInputProps>(
  ({ onFinishTyping, loading, placeholder, size = 'auto' }, ref) => {
    const { t } = useTranslation();
    const { value, setValue } = useTimeout(() => {
      onFinishTyping(value || '');
    }, 700);

    useImperativeHandle(ref, () => ({
      setValue(value) {
        setValue(value);
      },
    }));

    return (
      <div className="p-4 border-b border-grey-10 flex items-center w-full dark:border-grey-80">
        <Icon className="h-4 text-lg" color="black" svgName={'search'} />
        {!loading && (
          <input
            type="text"
            placeholder={placeholder || t('widget.historicalIndex.placeholder')}
            id="search-input"
            className={`pl-1 text-black dark:bg-grey-90 dark:text-white ${
              size === 'full' ? 'w-full' : 'w-auto'
            }`}
            autoComplete={'off'}
            value={value || ''}
            onChange={({ target: { value } }) => setValue(value)}
          />
        )}
        <div className={'flex w-24 justify-center mt-1'}>
          <Loading status={loading} size={'small'} />
        </div>
      </div>
    );
  }
);
